import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InputGeral from "../Componets/InputGeral";
import LabelGeral from "../Componets/LabelGeral";
import DateEmprestimo from "../Componets/DateGeral";
import Vector from "../imagem/Vector.svg";
import moment from "moment";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 360,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  height: 348,
  p: 4,
  borderRadius: 3,
};

export function hoje() {
  return moment().format("DD/MM/YYYY");
}

function RenovarEmpretimo({
  open,
  cancelar,
  renovar,
  titulo,
  aluno,
  dataDevolvendo,
  setDataDevolvendo,
}) {
  return (
    <div>
      <Modal
        open={open}
        onClose={cancelar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{ width: "100%", display: "flex", justifyContent: "end" }}
            >
              <Button onClick={cancelar}>
                <img src={Vector} alt="" />
              </Button>
            </div>
            <Typography variant="h6" component="h6">
              Renovar empréstimo
            </Typography>
            <Typography variant="p" component="p">
              {titulo}
            </Typography>
          </div>

          <div
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <LabelGeral
              nome="Nome"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                left: 10,
                fontFamily: "Roboto",
                fontSize: 20,
              }}
            />
            <InputGeral value={aluno} disabled={true} placeholder="" />
          </div>

          <div
            style={{
              display: "flex",
              marginTop: 25,
              justifyContent: "space-between",
            }}
          >
            <div>
              <LabelGeral
                nome="Data atual"
                estilo={{
                  display: "flex",
                  fontSize: 16,
                  marginBottom: "0.5em",
                }}
              />
              <input
                disabled
                style={{
                  color: "var(--cor-preto)",
                  backgroundColor: "var(--cor-branco)",
                  border: "1px solid var(--cor-cinzaMargin)",
                  fontSize: 18,
                  borderRadius: 10,
                  width: 160,
                  height: 40,
                  fontFamily: "Roboto",
                }}
                value={hoje()}
              />
            </div>
            <div>
              <LabelGeral
                nome="Data de entrega"
                style={{
                  display: "flex",
                  fontFamily: "Roboto",
                  fontSize: 16,
                }}
              />

              <DateEmprestimo
                dataDevolvendo={dataDevolvendo}
                setDataDevolvendo={setDataDevolvendo}
              />
            </div>
          </div>

          <div
            className="buttons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <Button
              onClick={cancelar}
              variant="contained"
              style={{
                color: "var(--cor-roxoEscuro)",
                backgroundColor: "var(--cor-roxoClaro)",
                border: "solid var(--cor-roxoEscuro)",
                borderRadius: "0.5em",
                fontSize: 20,
                width: 160,
                top: 34,
                boxShadow: 'none'
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={renovar}
              variant="contained"
              style={{
                color: "var(--cor-branco)",
                backgroundColor: "var(--cor-roxoEscuro)",
                border: "solid var(--cor-roxoEscuro)",
                borderRadius: "0.5em",
                fontSize: 20,
                width: 160,
                top: 34,
                boxShadow: 'none'
              }}
            >
              Renovar
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default RenovarEmpretimo;